import "./style.scss";
import * as React from "react";
import _ from "lodash";
import Feature from "../../../../modules/common/components/Feature";
import { Button, Modal, Radio, Icon, message } from "antd";
import { SearchSelect } from "../../../AnalyticsMetric/components/Dropdown";
import { hasFinancePermissions } from "../../../AnalyticsMetric/constants";
import { ReportOption } from "./ReportOption";

interface ModalContentsProps {
  value: string;
  publications: any[];
  selectedPublication: any;
  versions: any[];
  selectedVersion: any;
  metrics: string[];
  selectedMetric: string;
  hasFinancePermissions: boolean;
  fetchingVersions?: boolean;
  onRadioChange: (e: any) => void;
  handleVersionSelect: (id: number) => void;
  handlePublicationSelect: (id: number) => void;
  handleMetricSelect: (metric: string) => void;
}

const toMetricObject = (metric: string) => ({
  key: metric,
  name: _.startCase(metric)
});

export const ModalContents = (props: ModalContentsProps) => (
  <div className="modal-contents">
    <Radio.Group value={props.value} onChange={props.onRadioChange}>
      <ReportOption
        value="reach"
        description="Columns: Publication, Merchant Name, Available From, Available To, Date, Device, Channel, Impressions, Opens, Unique Engaged Visits, Clicks, Average Time On Flyer."
      />
      <ReportOption
        value="audience"
        description="Columns: Publication, Flyer Name, Available From, Available To, Channel, State, DMA, City, Opens, Clicks, Unique Engaged Visits, TTM."
      />
      {props.hasFinancePermissions && (
        <ReportOption
          value="finance"
          description="Columns: Flyer Type Name, Flyer Name, Available From, Available To, Date, Billable Engagements, Amount."
        />
      )}
      <ReportOption
        style={{ marginBottom: 10 }}
        value="content-publication"
        description="Columns: Publication, Channel, Device, Name, SKU, Views, Clicks, Shopping List, Add to Cart."
      />
      <div
        data-automation-id="content-publication-selectors"
        style={{ marginLeft: 22, marginBottom: 40 }}
      >
        {props.publications && (
          <SearchSelect
            placeholder="Select a Publication..."
            objects={props.publications}
            selectedObject={props.selectedPublication}
            idKey={"flyer_run_id"}
            valueKey={"flyer_run_name"}
            size={"small"}
            handleSelection={props.handlePublicationSelect}
          />
        )}
      </div>
      <ReportOption
        value="content-version"
        description="Columns: Publication, Merchant Name, Available From, Available To, Date, Device, Channel, Impressions, Opens, Unique Engaged Visits, Clicks, Average Time On Flyer."
      />
      <div
        data-automation-id="content-version-selectors"
        style={{ marginLeft: 22 }}
      >
        <SearchSelect
          placeholder="Select Publication..."
          objects={props.publications}
          selectedObject={props.selectedPublication}
          idKey="flyer_run_id"
          valueKey="flyer_run_name"
          size="small"
          handleSelection={props.handlePublicationSelect}
        />
        <SearchSelect
          placeholder="Select Version..."
          objects={props.versions}
          selectedObject={props.selectedVersion}
          fetching={props.fetchingVersions}
          idKey="flyer_id"
          valueKey="flyer_name"
          size="small"
          handleSelection={props.handleVersionSelect}
        />
        <SearchSelect
          placeholder="Select Heatmap Metric..."
          objects={props.metrics.map(toMetricObject)}
          selectedObject={
            props.selectedMetric ? toMetricObject(props.selectedMetric) : null
          }
          idKey="key"
          valueKey="name"
          size="small"
          handleSelection={props.handleMetricSelect}
        />
      </div>
    </Radio.Group>
  </div>
);



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/DataExport/ModalContents.tsx